
export const downloader = (url: string, filename: any = '') => {
  if (!filename) {
    filename = url.length > 0 ? new URL(url).pathname.split('/').at(-1) : 'noname'

  }

  const download = (url: any) => {
    const link = document.createElement('a');

    link.setAttribute('download', filename);
    link.setAttribute('href', url);
    link.click();
  }

  const downloadBlob = (blob: any) => download(URL.createObjectURL(blob))

  fetch(url)
    .then(response => response.blob())
    .then(downloadBlob)

}